export default __webpack_public_path__ + "static/media/Group8876.851517d0.svg";